export function toFloat(val: number | string): number {
  return typeof val === 'string' ? Number.parseFloat(val.replace(/,/g, '')) : val;
}

export function toInt(val: number | string): number {
  return typeof val === 'string' ? Number.parseInt(val.replace(/,/g, '')) : val;
}
